(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["entry-popup"] && !Shopify.designMode) return;
  try {
    
/* NOTE: {% javascript %} is bundled once per section TYPE (shared across every
   instance on the page), so Liquid tags are NOT evaluated inside it — there is
   no per-instance {{ section.id }} available here. Every dynamic value must
   come from the DOM (id/data-* attributes, which Liquid already rendered into
   the markup above) instead. We loop over every .entry-popup in case more
   than one is ever added, deriving each instance's id from its own element id. */
(function () {
  document.querySelectorAll('.entry-popup').forEach(function (modal) {
    var sectionId = modal.id.replace(/^EntryPopup-/, '');
    var badge = document.getElementById('EntryPopupBadge-' + sectionId);
    var stage = modal.querySelector('.entry-popup__stage');
    var trigger = modal.querySelector('[data-reveal-trigger]');
    var copyBtn = modal.querySelector('[data-copy-code]');
    var badgeReopen = badge ? badge.querySelector('[data-badge-reopen]') : null;
    var badgeClose = badge ? badge.querySelector('[data-badge-close]') : null;

    var STORAGE_SHOWN = 'entry-popup-shown-' + sectionId;
    var STORAGE_BADGE_DISMISSED = 'entry-popup-badge-dismissed-' + sectionId;

    function shouldAutoShow() {
      var frequency = modal.dataset.frequency;
      if (frequency === 'always') return true;
      if (frequency === 'session') return !sessionStorage.getItem(STORAGE_SHOWN);
      if (frequency === 'days') {
        var days = parseInt(modal.dataset.frequencyDays, 10) || 7;
        var last = localStorage.getItem(STORAGE_SHOWN);
        if (!last) return true;
        return (Date.now() - parseInt(last, 10)) / 86400000 >= days;
      }
      return true;
    }

    function markShown() {
      var frequency = modal.dataset.frequency;
      if (frequency === 'session') sessionStorage.setItem(STORAGE_SHOWN, '1');
      if (frequency === 'days') localStorage.setItem(STORAGE_SHOWN, String(Date.now()));
    }

    function openModal() {
      modal.show();
    }

    function showBadge() {
      if (!badge || sessionStorage.getItem(STORAGE_BADGE_DISMISSED)) return;
      badge.hidden = false;
    }

    function hideBadge() {
      if (badge) badge.hidden = true;
    }

    // Auto-open on first load, gated by the chosen frequency.
    if (shouldAutoShow()) {
      var delay = parseInt(modal.dataset.delay, 10) || 2500;
      window.setTimeout(function () {
        openModal();
        markShown();
      }, delay);
    }

    // Reveal the prize when the sachet is clicked.
    if (trigger) {
      trigger.addEventListener('click', function () {
        stage.setAttribute('data-stage', 'prize');
      });
    }

    // Optional live countdown (e.g. "Offer ends in 2d 04h 12m 30s").
    var countdownEl = modal.querySelector('[data-countdown-end]');
    if (countdownEl) {
      var endTime = new Date(countdownEl.dataset.countdownEnd).getTime();
      var dEl = countdownEl.querySelector('[data-cd-days]');
      var hEl = countdownEl.querySelector('[data-cd-hours]');
      var mEl = countdownEl.querySelector('[data-cd-mins]');
      var sEl = countdownEl.querySelector('[data-cd-secs]');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var remaining = endTime - Date.now();
        if (!endTime || isNaN(endTime) || remaining <= 0) {
          countdownEl.hidden = true;
          window.clearInterval(timer);
          return;
        }
        var totalSeconds = Math.floor(remaining / 1000);
        dEl.textContent = pad(Math.floor(totalSeconds / 86400));
        hEl.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
        mEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        sEl.textContent = pad(totalSeconds % 60);
      };
      tick();
      var timer = window.setInterval(tick, 1000);
    }

    // Watch THIS modal's own [open] attribute rather than the global
    // 'modalClosed' event: that event fires on document.body for every
    // modal-dialog on the page (search, product popups, etc.) and — since
    // hide() dispatches it BEFORE removing the [open] attribute — checking
    // hasAttribute('open') inside that handler is unreliable anyway.
    var wasOpen = modal.hasAttribute('open');
    new MutationObserver(function () {
      var isOpen = modal.hasAttribute('open');
      if (wasOpen && !isOpen) showBadge();
      wasOpen = isOpen;
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    if (badgeReopen) {
      badgeReopen.addEventListener('click', function () {
        hideBadge();
        openModal();
      });
    }

    if (badgeClose) {
      badgeClose.addEventListener('click', function (event) {
        event.stopPropagation();
        sessionStorage.setItem(STORAGE_BADGE_DISMISSED, '1');
        hideBadge();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.closest('[data-code]').dataset.code;
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(code).then(function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied!';
          window.setTimeout(function () {
            copyBtn.textContent = original;
          }, 2000);
        }).catch(function () {
          /* clipboard permission denied — silently ignore, code is still visible in the pill */
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
